import "./asnGRNViewDetails.css";
import React, { useState, useEffect, useCallback } from "react";
import { GET_GROWER_BASIC_DETAILS, GET_DBS_SCHEDULE_LIST, GET_GROWER_LAND_LIST, CREATE_DBS_ANS, FETCH_MAPPED_STAKEHOLDER_BY_TYPE_URN, GET_VEHICLE_DETAILS_BY_REG_NO, CREATE_DBS_ASN_LIST, SPLIT_DBS_SCHEDULE, GET_DRIVER_DETAILS_BY_LICENSE_NO } from '../../../common/URLs';

import "bootstrap/dist/css/bootstrap.min.css";
import { loaderService } from "../../../common/custom-loader/loader-service";
import { API_DATE_FORMAT, BASIC_DATE_FORMAT, DRIVING_LICENSE, PIT_ROLES, PROD, WEIGHT_ERROR } from "../../../common/constants";
import Button from '@mui/material/Button';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { toast } from 'react-toastify';
import { Card, CardContent, Box, Select, TextField, Typography, Container, FormLabel, Radio, Grid, RadioGroup, FormControlLabel, Divider, FormControl, InputLabel, MenuItem, FormHelperText, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, Tooltip, Paper } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import moment from 'moment';
import { VALIDATION, addressMaxLength, maxNameLength, mobileNoMaxLength, mobileNumberValidation, nameValidation } from "../../../common/commonValidations";
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { useTranslation } from 'react-i18next';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { FileUploadMUI } from "../../../common/fileUpload/fileUploadMUI";
import { Add as AddIcon } from '@mui/icons-material';
import { isDisabled } from "@testing-library/user-event/dist/utils";
import { handleNumberFieldFocus } from "../../../common/commonFunction";
import jwt from 'jwt-decode';
import { DeleteIcon, ProceedIcon, SubmitIcon, ViewIcon } from "../../../common/icons";
import BadgeComponent from "../../../common/badge";
import apiClient from "../../../axios";

function AsnGrnViewDetails() {
    const { t } = useTranslation();
    const decoded = jwt(getLocalStorageItem('id_token'));
    const [vehicleInfo, setVehicleInfo] = useState();
    const [vehicleScheduleList, setVehicleScheduleList] = useState([]);
    const [dbsDetail, setDbsDetail] = useState({
        urn: "",
        landId: "",
        name: "",
        mobileNo: "",
        address: "",
        destinationStakeholderType: decoded.extension_URN ? localStorage.getItem("stakeholderCategory") : "",
        destinationStakeholderUrn: decoded.extension_URN ? localStorage.getItem("urn") : "",
    });
    const [details, setDetails] = useState({
        vehicleType: "",
        vehicleOwnerType: "",
        grossVehicleWeight: "",
        unladenWeight: "",
        vehicleMake: "",
        vehicleModel: "",
        vehicleAge: "",
        vehicleRegistrationNo: "",
        registrationEndDate: new Date(),
        insuranceNo: "",
        insuranceEnddate: new Date(),
        puccNo: "",
        puccEndDate: new Date(),
        fitnessNo: "",
        fitnessEndDate: new Date(),
        driverName: "",
        licenseNo: "",
        driverContactNo: "",
        licenceIssueDate: "",
        licenceValidityEnddate: "",
        expectedWeight: "",
        dbsScheduleList: []
    });

    const [isUrnValid, setIsUrnValid] = useState(false);
    const [proceed, setProceed] = useState(false);
    const [categoryList, setCategoryList] = useState(["LLE", "Plant", "Interim Storage Operator"]);
    const [growerLandList, setGrowerLandList] = useState([]);
    const [destinationUrnsList, setDestinationUrnsList] = useState();
    const [dbsScheduleList, setDbsScheduleList] = useState([]);
    const [vehicleDetails, setVehicleDetails] = useState([]);
    const [openView, setOpenView] = React.useState(false);
    const [selectedSchedules, setSelectedSchedules] = useState([]);
    const [disabledSchedules, setDisabledSchedules] = useState([]);
    const [totalScheduleQty, setTotalScheduleQty] = useState(0);
    const [isApiCalled, setIsApiCalled] = useState(false);

    const [errorMessage, setErrorMessage] = useState({
        urn: "",
        landId: "",
        name: "",
        mobileNo: "",
        address: "",
        destinationStakeholderType: "",
        destinationStakeholderUrn: "",
        vehicleType: "",
        vehicleOwnerType: "",
        grossVehicleWeight: "",
        unladenWeight: "",
        vehicleMake: "",
        vehicleModel: "",
        vehicleAge: "",
        vehicleRegistrationNo: "",
        registrationEndDate: "",
        insuranceNo: "",
        insuranceEnddate: "",
        puccNo: "",
        puccEndDate: "",
        fitnessNo: "",
        fitnessEndDate: "",
        driverName: "",
        licenseNo: "",
        driverContactNo: "",
        licenceIssueDate: "",
        licenceValidityEnddate: "",
        vehicleRegistrationDoc: "",
        vehicleInsuranceDoc: "",
        vehiclePuccDoc: "",
        vehicleFitnessDoc: "",
        expectedWeight: ""
    });
    const [documentsArray, setDocumentsArray] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);

    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);

    const [logModalOpen2, setLogModalOpen2] = useState(false);
    const handleLogModalOpen2 = () => setLogModalOpen2(true);
    const handleLogModalClose2 = () => setLogModalOpen2(false);

    const handleChange = (e) => {
        setErrorMessage({ ...errorMessage, [e.target.name]: "" });
        setDetails({ ...details, [e.target.name]: e.target.value });
        if (e.target.name === 'grossVehicleWeight') {
            const slicedValue = VALIDATION.weightsSlicedValue(e.target.value);
            const vehicleWeightValidation = VALIDATION.weightsValidation(details.vehicleType, slicedValue);
            setDetails({ ...details, [e.target.name]: slicedValue });
            if (slicedValue.length === 0) {
                setErrorMessage({ ...errorMessage, [e.target.name]: 'Please enter Vehicle weight' });
            } else if (vehicleWeightValidation) {
                setErrorMessage({ ...errorMessage, [e.target.name]: vehicleWeightValidation });
            } else setErrorMessage({ ...errorMessage, [e.target.name]: "" });
        }
        if (e.target.name === 'unladenWeight') {
            setDetails({ ...details, [e.target.name]: VALIDATION.weightsSlicedValue(e.target.value) });
            if ((e.target.value.toString()).length <= 5) {
                setErrorMessage({ ...errorMessage, [e.target.name]: '' });
            } else setErrorMessage({ ...errorMessage, [e.target.name]: WEIGHT_ERROR });
        }
        if (e.target.name === 'vehicleMake') {
            if ((e.target.value.toString()).length > 0) {
                setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 50)) });
                setErrorMessage({ ...errorMessage, [e.target.name]: '' });
            } else {
                setErrorMessage({ ...errorMessage, [e.target.name]: "Please enter Vehicle Make" });
            }
        }
        if (e.target.name === 'vehicleModel') {
            if ((e.target.value.toString()).length > 0) {
                setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 50)) });
                setErrorMessage({ ...errorMessage, [e.target.name]: '' });
            } else setErrorMessage({ ...errorMessage, [e.target.name]: "Please enter Vehicle Model" });
        }
        if (e.target.name === 'vehicleAge') {
            if ((e.target.value.toString()).length > 0) {
                setDetails({ ...details, [e.target.name]: e.target.value.slice(0, 2) });
                setErrorMessage({ ...errorMessage, [e.target.name]: '' });
            } else setErrorMessage({ ...errorMessage, [e.target.name]: "Please enter Vehicle Age" });
        }
        if (e.target.name === 'vehicleRegistrationNo') {
            if ((e.target.value.toString()).length > 0) {
                if (VALIDATION.registrationNumberValidation(e.target.value)) {
                    setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 50)) });
                } else setErrorMessage({ ...errorMessage, [e.target.name]: 'Please enter valid Registration Number' });
            } else setErrorMessage({ ...errorMessage, [e.target.name]: 'Please enter valid Registration Number' });
        }
        if (e.target.name === 'insuranceNo') {
            if ((e.target.value.toString()).length > 0) {
                setErrorMessage({ ...errorMessage, [e.target.name]: '' });
                setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 50)) });
            } else setErrorMessage({ ...errorMessage, [e.target.name]: 'Please enter valid Insurance No.' });
        }
        if (e.target.name === 'puccNo') {
            if ((e.target.value.toString()).length > 0) {
                setErrorMessage({ ...errorMessage, [e.target.name]: '' });
                setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 50)) });
            } else setErrorMessage({ ...errorMessage, [e.target.name]: 'Please enter valid PUCC No.' });
        }
        if (e.target.name === 'fitnessNo') {
            if ((e.target.value.toString()).length > 0) {
                setErrorMessage({ ...errorMessage, [e.target.name]: '' });
                setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 50)) });
            } else setErrorMessage({ ...errorMessage, [e.target.name]: 'Please enter valid Fitness No.' });
        }
        if (e.target.name === 'driverName') {
            if ((e.target.value.toString()).length > 0) {
                setDetails({ ...details, [e.target.name]: (e.target.value.slice(0, 60)) });
                setErrorMessage({ ...errorMessage, [e.target.name]: '' });
            } else {
                setErrorMessage({ ...errorMessage, [e.target.name]: "Please enter Driver Name" });
            }
        }
        if (e.target.name === "driverContactNo") {
            setDetails({ ...details, [e.target.name]: mobileNumberValidation(e.target.value) });
            if (e.target.value.length < 10) {
                setErrorMessage({ ...errorMessage, [e.target.name]: "Please enter 10 digit mobile number" });
            } else setErrorMessage({ ...errorMessage, [e.target.name]: "" });
        }
        if (e.target.name === 'expectedWeight') {
            if ((e.target.value.toString()).length < 0) {
                setErrorMessage({ ...errorMessage, [e.target.name]: 'Please enter expected weight' });
            }
            if ((e.target.value > totalScheduleQty)) {
                setErrorMessage({ ...errorMessage, [e.target.name]: 'Expected weight cannot be greater than total weight of selected schedules' });
            } else {
                setErrorMessage({ ...errorMessage, [e.target.name]: '' });
                setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 10)) });
            }
        }
        if (e.target.name === 'licenseNo') {
            if ((e.target.value.toString()).length > 0) {
                setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 20)) });
                setErrorMessage({ ...errorMessage, [e.target.name]: '' });
            } else {
                setErrorMessage({ ...errorMessage, [e.target.name]: "Please enter license number" });
            }
        }
    };

    const handleInputChange = (e) => {
        setErrorMessage({ ...errorMessage, [e.target.name]: "" });
        setDbsDetail({ ...dbsDetail, [e.target.name]: e.target.value });
        if (e.target.name === "urn") {
            setIsUrnValid(false);
            setDbsDetail({ ...dbsDetail, urn: (e.target.value).toUpperCase(), name: "", mobileNo: "", address: "" });
            setProceed(false);
        }
        if (e.target.name === "destinationStakeholderType") {
            setDbsDetail({ ...dbsDetail, [e.target.name]: e.target.value });
            getDestinationUrnsList(e.target.value);
            setProceed(false);
        }
        if (e.target.name === "destinationStakeholderUrn") {
            setDbsDetail({ ...dbsDetail, [e.target.name]: e.target.value });
            setProceed(false);
        }
    };

    const handleAddDetail = () => {
        let weightError = '';
        const isPlant = dbsDetail?.destinationStakeholderType === "Plant";
        var licenseDoc = documentsArray && documentsArray.filter((item) => item.documentType === DRIVING_LICENSE && item.isActive === 1);
        var fitnessDoc = documentsArray && documentsArray.filter((item) => item.documentType === "FitnessNo" && item.isActive === 1);
        var puccDoc = documentsArray && documentsArray.filter((item) => item.documentType === "VehiclePUCC" && item.isActive === 1);
        var insuranceDoc = documentsArray && documentsArray.filter((item) => item.documentType === "VehicleInsurance" && item.isActive === 1);
        var regDoc = documentsArray && documentsArray.filter((item) => item.documentType === "VehicleRegistration" && item.isActive === 1);

        if (selectedSchedules.length > 1) {
            selectedSchedules.forEach(element => {
                if (Number(details.expectedWeight) <= Number(element.scheduleRbCbQuantity)) {
                    return weightError = "true";
                } else {
                    return weightError = "false";
                }
            });
        }
        if (dbsScheduleList?.length === 0) {
            toast.error("There is no schedules available to create ASN");
        } else if (selectedSchedules?.length === 0) {
            toast.error("Please select at least one schedule from the table");
        } else if (Number(details.expectedWeight) > Number(totalScheduleQty)) {
            setErrorMessage({ ...errorMessage, expectedWeight: 'Expected weight cannot be greater than total weight of selected schedules' });
        } else if (!details.vehicleType) {
            setErrorMessage({ ...errorMessage, vehicleType: "Enter vehicle type" });
        } else if (!details.vehicleOwnerType) {
            setErrorMessage({ ...errorMessage, vehicleOwnerType: "Enter ownership type" });
        } else if (!details.grossVehicleWeight) {
            setErrorMessage({ ...errorMessage, grossVehicleWeight: "Enter gross vehicle weight" });
        } else if (!details.unladenWeight) {
            setErrorMessage({ ...errorMessage, unladenWeight: "Enter unladen weigth" });
        } else if (isPlant && !details.vehicleMake) setErrorMessage({ ...errorMessage, vehicleMake: "Enter vehicle make" });
        else if (isPlant && !details.vehicleModel) setErrorMessage({ ...errorMessage, vehicleModel: "Enter vehicle model" });
        else if (isPlant && !details.vehicleAge) setErrorMessage({ ...errorMessage, vehicleAge: "Enter vehicle age" });
        else if (!details.vehicleRegistrationNo || !VALIDATION.registrationNumberValidation(details.vehicleRegistrationNo)) {
            setErrorMessage({ ...errorMessage, vehicleRegistrationNo: "Enter valid vehicle registration number" });
        } else if (isPlant && (!regDoc || regDoc.length === 0)) {
            setErrorMessage({ registrationDocError: "Please upload Registration document" });
            toast.error("Please upload Registration document");
        } else if (isPlant && !details.insuranceNo) setErrorMessage({ ...errorMessage, insuranceNo: "Enter insurance no" });
        else if (isPlant && (!insuranceDoc || insuranceDoc.length === 0)) {
            setErrorMessage({ insurenaceDocError: "Please upload Insurance document" });
            toast.error("Please upload Insurance document");
        } else if (isPlant && !details.puccNo) setErrorMessage({ ...errorMessage, puccNo: "Enter pucc number" });
        else if (dbsDetail?.destinationStakeholderType === "Plant" && (!puccDoc || puccDoc.length === 0)) {
            setErrorMessage({ puccDocError: "Please upload PUCC document" });
            toast.error("Please upload PUCC document");
            return;
        } else if (isPlant && !details.fitnessNo) setErrorMessage({ ...errorMessage, fitnessNo: "Enter fitness number" });
        else if (isPlant && (!fitnessDoc || fitnessDoc.length === 0)) {
            setErrorMessage({ fitnessDocError: "Please upload Fitness document" });
            toast.error("Please upload Fitness document");
            return;
        } else if (!details.expectedWeight) {
            setErrorMessage({ ...errorMessage, expectedWeight: 'Enter expected weight in MT' });
        } else if (!details.driverName) {
            setErrorMessage({ ...errorMessage, driverName: "Enter driver name" });
        } else if (!details.licenseNo) {
            setErrorMessage({ ...errorMessage, licenseNo: "Enter license number" });
        } else if (isPlant && (!licenseDoc || licenseDoc.length === 0)) {
            setErrorMessage({ drivingLicenseDocError: "Please upload Driving License document" });
            toast.error("Please upload Driving License document");
        } else if (!details.driverContactNo) {
            setErrorMessage({ ...errorMessage, driverContactNo: "Enter driver contact number" });
        } else if (weightError === "true") {
            toast.error("Expected weight is available in a single schedule! Please remove the additional schedule from the list.");
        } else if (Number(details.expectedWeight) === Number(totalScheduleQty)) {
            if (!vehicleDetails?.find((v) => v.vehicleRegistrationNo === details?.vehicleRegistrationNo)) {
                const data = selectedSchedules.map((item) => ({
                    "scheduleId": item.scheduleId,
                    "weeklyScheduleNumber": item.weeklyScheduleNumber,
                    "scheduleLineNumber": item.scheduleLineNumber,
                    "schedulePickupDate": item.schedulePickupDate,
                    "scheduleRbCbQuantity": item.scheduleRbCbQuantity,
                    "poNumber": item.poNumber
                }));

                const newVehicle = {
                    ...details,
                    vehicleRegFileId: documentsArray?.find((item) => item.documentType === "VehicleRegistration")?.documentBlobName,
                    vehicleRegFileName: documentsArray?.find((item) => item.documentType === "VehicleRegistration")?.documentName,
                    licenseFileId: documentsArray?.find((item) => item.documentType === DRIVING_LICENSE)?.documentBlobName,
                    licenseFileName: documentsArray?.find((item) => item.documentType === DRIVING_LICENSE)?.documentName,
                    insuranceFileId: documentsArray?.find((item) => item.documentType === "VehicleInsurance")?.documentBlobName,
                    insuranceFileName: documentsArray?.find((item) => item.documentType === "VehicleInsurance")?.documentName,
                    puccFileId: documentsArray?.find((item) => item.documentType === "VehiclePUCC")?.documentBlobName,
                    puccFileName: documentsArray?.find((item) => item.documentType === "VehiclePUCC")?.documentName,
                    fitnessFileId: documentsArray?.find((item) => item.documentType === "FitnessNo")?.documentBlobName,
                    fitnessFileName: documentsArray?.find((item) => item.documentType === "FitnessNo")?.documentName,
                    dbsScheduleList: data
                };
                setVehicleDetails((prev) => [...prev, newVehicle]);
                setDisabledSchedules((prev) => [...prev, ...selectedSchedules.map((s) => s.scheduleId)]);
                setSelectedSchedules([]);
                setDetails({
                    vehicleType: "",
                    vehicleOwnerType: "",
                    grossVehicleWeight: "",
                    unladenWeight: "",
                    vehicleMake: "",
                    vehicleModel: "",
                    vehicleAge: "",
                    vehicleRegistrationNo: "",
                    registrationEndDate: new Date(),
                    insuranceNo: "",
                    insuranceEnddate: new Date(),
                    puccNo: "",
                    puccEndDate: new Date(),
                    fitnessNo: "",
                    fitnessEndDate: new Date(),
                    expectedWeight: "",
                    driverName: "",
                    licenseNo: "",
                    driverContactNo: "",
                    licenceIssueDate: "",
                    licenceValidityEnddate: "",
                    dbsScheduleList: []
                });
                setDocumentsArray([]);
            } else {
                toast.error("Vehicle already exists! Please remove or add different Vehicle!");
            }
        } else {
            handleLogModalOpen2();
        }
    };

    const handleRemoveDetail = (vehicleRowToRemove) => {
        const updatedData = [...vehicleDetails];
        setVehicleDetails(updatedData.filter((row) => row.vehicleRegistrationNo !== vehicleRowToRemove.vehicleRegistrationNo));
        setDisabledSchedules((prev) => prev.filter((id) => !vehicleRowToRemove?.dbsScheduleList?.map((s) => s.scheduleId).includes(id)));
        setDocumentsArray([]);
    };

    const getdetails = () => {
        loaderService.showLoader();
        apiClient
            .post(GET_GROWER_BASIC_DETAILS,
                { "growerUrn": dbsDetail.urn },
                { headers: { Authorization: 'Bearer ' + getLocalStorageItem('id_token') } }, null
            )
            .then((response) => {
                loaderService.hideLoader();
                if (response?.data?.stakeHolder) {
                    const displayName = [response?.data?.stakeHolder?.firstName, response?.data?.stakeHolder?.middleName, response?.data?.stakeHolder?.lastName];
                    setDbsDetail({
                        ...dbsDetail,
                        name: (response?.data?.stakeHolder?.subCategory !== "Individual") ? response?.data?.stakeHolder?.name : displayName?.filter(part => part)?.join(' '),
                        mobileNo: response?.data?.stakeHolder?.mobileNo,
                        address: response?.data?.stakeHolder?.address
                    });
                    setIsUrnValid(true);
                    getGrowerLandList();
                } else setErrorMessage({ ...errorMessage, urn: "Enter valid URN" });
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const getDestinationUrnsList = (stakeHolderType) => {
        loaderService.showLoader();
        apiClient.post(FETCH_MAPPED_STAKEHOLDER_BY_TYPE_URN,
            { "stakeholderType": "Grower", "stakeholderUrn": dbsDetail?.urn },
            { headers: { Authorization: 'Bearer ' + getLocalStorageItem('id_token'), "Content-Type": "application/json" } }
        )
            .then((response) => {
                const matchingObject = {
                    "LLE": "llleMappedPojo",
                    "Plant": "plantMappedPojo",
                    "Interim Storage Operator": "isMappedPojo",
                };
                if (response.data[matchingObject[stakeHolderType]] === null) {
                    setDestinationUrnsList([]);
                } else {
                    const uniqueArray = Array.from(new Set(response.data[matchingObject[stakeHolderType]].map(JSON.stringify))).map(JSON.parse);
                    setDestinationUrnsList(uniqueArray?.map((item) => item.stakeholderUrn));
                }
                loaderService.hideLoader();
            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const getGrowerLandList = () => {
        loaderService.showLoader();
        apiClient.post(GET_GROWER_LAND_LIST,
            { "growerUrn": dbsDetail.urn },
            { headers: { Authorization: 'Bearer ' + getLocalStorageItem('id_token'), "Content-Type": "application/json" } }
        )
            .then((response) => {
                setGrowerLandList(response.data.growerLandNameList);
                loaderService.hideLoader();
            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const getDbsScheduleList = () => {
        loaderService.showLoader();
        apiClient
            .post(GET_DBS_SCHEDULE_LIST,
                {
                    "dbsurn": dbsDetail.urn,
                    "destinationType": dbsDetail.destinationStakeholderType,
                    "destinationUrn": dbsDetail.destinationStakeholderUrn,
                    "landId": growerLandList?.find((item) => item.landId === dbsDetail.landId)?.landId
                },
                { headers: { Authorization: 'Bearer ' + getLocalStorageItem('id_token') } }, null
            )
            .then((response) => {
                loaderService.hideLoader();
                setDbsScheduleList(response.data.weeklySchedulePlanDetailsList);
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    useEffect(() => {
        if (details?.vehicleRegistrationNo && details?.vehicleRegistrationNo?.length >= 6) {
            getVehicleDetailsByRegNo();
        }
    }, [details?.vehicleRegistrationNo]);

    useEffect(() => {
        if (Array.isArray(vehicleDetails) && vehicleDetails.length > 0 && Array.isArray(dbsScheduleList)) {
            setVehicleDetails((prevVehicleDetails) =>
                prevVehicleDetails.map((vehicle) => {
                    const currentVehicleScheduleIds = (vehicle.dbsScheduleList || []).map(
                        (item) => item.scheduleId
                    );

                    const updatedVehicleSchedules = dbsScheduleList
                        .filter((schedule) => currentVehicleScheduleIds.includes(schedule.id))
                        .map((item) => ({
                            scheduleId: item.id,
                            weeklyScheduleNumber: item.weeklyScheduleNumber,
                            scheduleLineNumber: item.scheduleLineNumber,
                            schedulePickupDate: item.schedulePickupDate,
                            scheduleRbCbQuantity: item.scheduleRbCbQuantity,
                            poNumber: item.poNumber || item.poStpoNumber
                        }));

                    return {
                        ...vehicle,
                        dbsScheduleList: updatedVehicleSchedules.length > 0
                            ? updatedVehicleSchedules
                            : vehicle.dbsScheduleList,
                    };
                })
            );
        }
    }, [dbsScheduleList]);

    const getVehicleDetailsByRegNo = () => {
        loaderService.showLoader();
        apiClient.post(GET_VEHICLE_DETAILS_BY_REG_NO,
            { "vehicleRegNo": details?.vehicleRegistrationNo },
            { headers: { Authorization: 'Bearer ' + getLocalStorageItem('id_token'), "Content-Type": "application/json" } }
        )
            .then((response) => {
                setVehicleInfo(response.data.vehicleInfo);
                const tempArr = [];
                if (response.data.vehicleInfo?.vehicleRegFileId) {
                    tempArr.push({
                        id: null,
                        documentType: "VehicleRegistration",
                        documentName: response.data.vehicleInfo?.vehicleRegFileName,
                        documentBlobName: response.data.vehicleInfo?.vehicleRegFileId,
                        documentPath: null,
                        documentContainerName: "pit",
                        isActive: 1
                    });
                }
                if (response.data.vehicleInfo?.insuranceFileId) {
                    tempArr.push({
                        id: null,
                        documentType: "VehicleInsurance",
                        documentName: response.data.vehicleInfo?.insuranceFileName,
                        documentBlobName: response.data.vehicleInfo?.insuranceFileId,
                        documentPath: null,
                        documentContainerName: "pit",
                        isActive: 1
                    });
                }
                if (response.data.vehicleInfo?.puccFileId) {
                    tempArr.push({
                        id: null,
                        documentType: "VehiclePUCC",
                        documentName: response.data.vehicleInfo?.puccFileName,
                        documentBlobName: response.data.vehicleInfo?.puccFileId,
                        documentPath: null,
                        documentContainerName: "pit",
                        isActive: 1
                    });
                }
                if (response.data.vehicleInfo?.fitnessFileId) {
                    tempArr.push({
                        id: null,
                        documentType: "FitnessNo",
                        documentName: response.data.vehicleInfo?.fitnessFileName,
                        documentBlobName: response.data.vehicleInfo?.fitnessFileId,
                        documentPath: null,
                        documentContainerName: "pit",
                        isActive: 1
                    });
                }
                setDocumentsArray(tempArr);
                setDbsDetail({
                    urn: dbsDetail?.urn,
                    landId: dbsDetail.landId,
                    name: dbsDetail.name,
                    mobileNo: dbsDetail.mobileNo,
                    address: dbsDetail.address,
                    destinationStakeholderType: dbsDetail.destinationStakeholderType,
                    destinationStakeholderUrn: dbsDetail.destinationStakeholderUrn,
                });
                setDetails({
                    vehicleType: response.data.vehicleInfo?.vehicleType ? response.data.vehicleInfo?.vehicleType : details?.vehicleType,
                    vehicleOwnerType: response.data.vehicleInfo?.vehicleOwnerType ? response.data.vehicleInfo?.vehicleOwnerType : details?.vehicleOwnerType,
                    grossVehicleWeight: response.data.vehicleInfo?.grossVehicleWeight ? response.data.vehicleInfo?.grossVehicleWeight : details?.grossVehicleWeight,
                    unladenWeight: response.data.vehicleInfo?.unladenWeight ? response.data.vehicleInfo?.unladenWeight : details?.unladenWeight,
                    vehicleMake: response.data.vehicleInfo?.vehicleMake ? response.data.vehicleInfo?.vehicleMake : details?.vehicleMake,
                    vehicleModel: response.data.vehicleInfo?.vehicleModel ? response.data.vehicleInfo?.vehicleModel : details?.vehicleModel,
                    vehicleAge: response.data.vehicleInfo?.vehicleAge ? response.data.vehicleInfo?.vehicleAge : details?.vehicleAge,
                    vehicleRegistrationNo: response.data.vehicleInfo?.vehicleRegNo ? response.data.vehicleInfo?.vehicleRegNo : details?.vehicleRegistrationNo,
                    registrationEndDate: response.data.vehicleInfo?.regEndDate ? response.data.vehicleInfo?.regEndDate : new Date(),
                    insuranceNo: response.data.vehicleInfo?.insuranceNo ? response.data.vehicleInfo?.insuranceNo : details?.insuranceNo,
                    insuranceEnddate: response.data.vehicleInfo?.insuranceEnddate ? response.data.vehicleInfo?.insuranceEnddate : new Date(),
                    puccNo: response.data.vehicleInfo?.puccNo ? response.data.vehicleInfo?.puccNo : details?.puccNo,
                    puccEndDate: response.data.vehicleInfo?.puccEndDate ? response.data.vehicleInfo?.puccEndDate : new Date(),
                    fitnessNo: response.data.vehicleInfo?.fitnessNo ? response.data.vehicleInfo?.fitnessNo : details?.fitnessNo,
                    fitnessEndDate: response.data.vehicleInfo?.fitnessEndDate ? response.data.vehicleInfo?.fitnessEndDate : new Date(),
                    expectedWeight: (Number(response.data.vehicleInfo?.grossVehicleWeight) - Number(response.data.vehicleInfo?.unladenWeight)) / 1000,
                    driverName: details.driverName,
                    licenseNo: details.licenseNo,
                    driverContactNo: details.driverContactNo,
                    licenceIssueDate: details.licenceIssueDate,
                    licenceValidityEnddate: new Date(),
                    dbsScheduleList: vehicleScheduleList ? vehicleScheduleList : []
                });
                setErrorMessage({
                    vehicleType: "",
                    vehicleOwnerType: "",
                    grossVehicleWeight: "",
                    unladenWeight: "",
                    vehicleMake: "",
                    vehicleModel: "",
                    vehicleAge: "",
                    vehicleRegistrationNo: "",
                    registrationEndDate: "",
                    insuranceNo: "",
                    insuranceEnddate: "",
                    puccNo: "",
                    puccEndDate: "",
                    fitnessNo: "",
                    fitnessEndDate: "",
                    vehicleRegistrationDoc: "",
                    vehicleInsuranceDoc: "",
                    vehiclePuccDoc: "",
                    vehicleFitnessDoc: "",
                    expectedWeight: ""
                });
                loaderService.hideLoader();
            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    useEffect(() => {
        if (details?.licenseNo && details?.licenseNo?.length >= 3) {
            getDetailsByLicenseNo();
        }
    }, [details?.licenseNo]);

    const getDetailsByLicenseNo = () => {
        loaderService.showLoader();
        apiClient.post(GET_DRIVER_DETAILS_BY_LICENSE_NO,
            { "driverLicenseNo": details?.licenseNo },
            { headers: { Authorization: 'Bearer ' + getLocalStorageItem('id_token'), "Content-Type": "application/json" } }
        )
            .then((response) => {
                setDetails((prev) => ({
                    ...prev,
                    driverName: response.data.driverInfo?.driverName ? response.data.driverInfo?.driverName : details?.driverName,
                    licenseNo: response.data.driverInfo?.licenseNo ? response.data.driverInfo?.licenseNo : details?.licenseNo,
                    driverContactNo: response.data.driverInfo?.driverContact ? response.data.driverInfo?.driverContact : details?.driverContactNo,
                    licenceIssueDate: response.data.driverInfo?.licenseIssueDate ? response.data.driverInfo?.licenseIssueDate : new Date(),
                    licenceValidityEnddate: response.data.driverInfo?.licenseEndDate ? response.data.driverInfo?.licenseEndDate : new Date(),
                }));

                if (response.data.driverInfo?.licenseFileId) {
                    const driverDoc = {
                        id: null,
                        documentType: DRIVING_LICENSE,
                        documentName: response.data.driverInfo?.licenseFileName,
                        documentBlobName: response.data.driverInfo?.licenseFileId,
                        documentContainerName: "pit",
                        isActive: 1,
                    };
                    setDocumentsArray((prev) => {
                        const i = prev.findIndex((d) => d?.documentType === DRIVING_LICENSE);
                        if (i !== -1) {
                            const copy = [...prev];
                            copy[i] = { ...copy[i], ...driverDoc };
                            return copy;
                        }
                        return [...prev, driverDoc];
                    });
                }
                loaderService.hideLoader();
            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const splitDbsSchedule = () => {
        const splitData = selectedSchedules?.map((item) => {
            return {
                "scheduleId": item.scheduleId,
                "weeklyScheduleNumber": item.weeklyScheduleNumber,
                "scheduleLineNumber": item.scheduleLineNumber,
                "scheduleWeight": item.scheduleRbCbQuantity
            };
        });
        loaderService.showLoader();
        apiClient.post(SPLIT_DBS_SCHEDULE,
            {
                "scheduleStakeholderType": dbsScheduleList[0].scheduleStakeholderType,
                "scheduleStakeholderUrn": dbsScheduleList[0].stakeholderUrn,
                "expectedWeight": details.expectedWeight,
                "selectedScheduleList": splitData
            },
            { headers: { Authorization: 'Bearer ' + getLocalStorageItem('id_token'), "Content-Type": "application/json" } }
        )
            .then((response) => {
                if (response.data.isSuccess === true) {
                    getDbsScheduleList();
                    if (!vehicleDetails?.find((v) => v.vehicleRegistrationNo === details?.vehicleRegistrationNo)) {
                        const data = selectedSchedules.map((item) => ({
                            "scheduleId": item.scheduleId,
                            "weeklyScheduleNumber": item.weeklyScheduleNumber,
                            "scheduleLineNumber": item.scheduleLineNumber,
                            "schedulePickupDate": item.schedulePickupDate,
                            "scheduleRbCbQuantity": item.scheduleRbCbQuantity,
                            "poNumber": item.poNumber
                        }));
                        const newVehicle = {
                            ...details,
                            vehicleRegFileId: documentsArray?.find((item) => item.documentType === "VehicleRegistration")?.documentBlobName,
                            vehicleRegFileName: documentsArray?.find((item) => item.documentType === "VehicleRegistration")?.documentName,
                            licenseFileId: documentsArray?.find((item) => item.documentType === DRIVING_LICENSE)?.documentBlobName,
                            licenseFileName: documentsArray?.find((item) => item.documentType === DRIVING_LICENSE)?.documentName,
                            insuranceFileId: documentsArray?.find((item) => item.documentType === "VehicleInsurance")?.documentBlobName,
                            insuranceFileName: documentsArray?.find((item) => item.documentType === "VehicleInsurance")?.documentName,
                            puccFileId: documentsArray?.find((item) => item.documentType === "VehiclePUCC")?.documentBlobName,
                            puccFileName: documentsArray?.find((item) => item.documentType === "VehiclePUCC")?.documentName,
                            fitnessFileId: documentsArray?.find((item) => item.documentType === "FitnessNo")?.documentBlobName,
                            fitnessFileName: documentsArray?.find((item) => item.documentType === "FitnessNo")?.documentName,
                            dbsScheduleList: data
                        };
                        setVehicleDetails((prev) => [...prev, newVehicle]);
                        setDisabledSchedules((prev) => [...prev, ...selectedSchedules.map((s) => s.scheduleId)]);
                        toast.success(response.data.message);
                        setSelectedSchedules([]);
                        setDetails({
                            vehicleType: "",
                            vehicleOwnerType: "",
                            grossVehicleWeight: "",
                            unladenWeight: "",
                            vehicleMake: "",
                            vehicleModel: "",
                            vehicleAge: "",
                            vehicleRegistrationNo: "",
                            registrationEndDate: new Date(),
                            insuranceNo: "",
                            insuranceEnddate: new Date(),
                            puccNo: "",
                            puccEndDate: new Date(),
                            fitnessNo: "",
                            fitnessEndDate: new Date(),
                            expectedWeight: "",
                            driverName: "",
                            licenseNo: "",
                            driverContactNo: "",
                            licenceIssueDate: "",
                            licenceValidityEnddate: "",
                            dbsScheduleList: []
                        });
                    } else {
                        toast.error("Vehicle already exists! Please remove or add different Vehicle!");
                    }
                } else if (response.data.isSuccess === false) toast.error(response.data.message);
                loaderService.hideLoader();
            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const createDbsAsn = () => {
        loaderService.showLoader();
        apiClient
            .post(CREATE_DBS_ASN_LIST,
                {
                    "dbsUrn": dbsDetail.urn,
                    "landId": dbsDetail.landId,
                    "dbsName": dbsDetail.name,
                    "dbsContactNo": dbsDetail.mobileNo,
                    "dbsAddress": dbsDetail.address,
                    "destinationStakeholderType": dbsDetail.destinationStakeholderType,
                    "destinationStakeholderUrn": dbsDetail.destinationStakeholderUrn,
                    "dbsVehicleList": vehicleDetails,
                },
                { headers: { Authorization: 'Bearer ' + getLocalStorageItem('id_token') } }, null
            )
            .then((response) => {
                loaderService.hideLoader();
                if (response.data.isSuccess === true) {
                    toast.success(response.data.message);
                    getDbsScheduleList();
                    setSelectedRows([]);
                    setProceed(false);
                    setDetails({
                        ...details,
                        vehicleType: "",
                        vehicleOwnerType: "",
                        grossVehicleWeight: '',
                        unladenWeight: "",
                        vehicleMake: "",
                        vehicleModel: "",
                        vehicleAge: "",
                        vehicleRegistrationNo: "",
                        registrationEndDate: new Date(),
                        insuranceNo: "",
                        insuranceEnddate: new Date(),
                        puccNo: "",
                        puccEndDate: new Date(),
                        fitnessNo: "",
                        fitnessEndDate: new Date(),
                        expectedWeight: "",
                        driverName: "",
                        licenseNo: "",
                        driverContactNo: "",
                        licenceIssueDate: "",
                        licenceValidityEnddate: "",
                        dbsScheduleList: []
                    });
                    setVehicleDetails([]);
                    setDisabledSchedules([]);
                    setSelectedSchedules([]);
                    setDocumentsArray([]);
                } else if (response.data.isSuccess === false) toast.error(response.data.message);
                else toast.error("Something went wrong, Please try again!");
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const getDetails = () => {
        if (!dbsDetail.urn) {
            setErrorMessage({ ...errorMessage, urn: "Please Enter URN" });
        } else {
            getdetails();
        }
    };

    const onProceed = () => {
        if (!isUrnValid) {
            setErrorMessage({ ...errorMessage, urn: "Enter URN and get details" });
        } else if (!dbsDetail.landId) {
            setErrorMessage({ ...errorMessage, landId: "Select the land" });
        } else if (!dbsDetail.destinationStakeholderType) {
            setErrorMessage({ ...errorMessage, destinationStakeholderType: "Enter destination stakeholder type" });
        } else if (!dbsDetail.destinationStakeholderUrn) {
            setErrorMessage({ ...errorMessage, destinationStakeholderUrn: "Enter destination stakeholder urn" });
        } else {
            getDbsScheduleList();
            setProceed(true);
        }
    };

    const columns = [
        { field: 'weeklyScheduleNumber', headerName: 'Weekly Schedule No', width: 250 },
        { field: 'scheduleLineNumber', headerName: 'Schedule Line No', width: 132 },
        {
            field: 'schedulePickupDate', headerName: 'Schedule Date', width: 130,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        { field: 'scheduleRbCbQuantity', headerName: 'Schedule Weight', width: 130 },
        { field: 'poStpoNumber', headerName: 'PO Number', width: 130 },
        { field: 'poQuantity', headerName: 'PO Quantity(MT)', width: 130 },
        { field: 'poBalanceQuantity', headerName: 'PO Balance Quantity(MT)', width: 130 },
        { field: 'secondPartyType', headerName: 'Destination Type', width: 130 },
        { field: 'secondPartyUrn', headerName: 'Destination Urn', width: 150 }
    ];

    const viewScheduleCol = [
        { field: 'weeklyScheduleNumber', headerName: 'Weekly Schedule No', width: 250 },
        { field: 'scheduleLineNumber', headerName: 'Schedule Line No', width: 132 },
        {
            field: 'schedulePickupDate', headerName: 'Schedule Date', width: 130,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        { field: 'expectedWeight', headerName: 'Expected Weight', width: 130 },
        { field: 'scheduleRbCbQuantity', headerName: 'Schedule Weight', width: 130 },
        { field: 'poNumber', headerName: 'PO Number', width: 130 },
        { field: 'destinationType', headerName: 'Destination Type', width: 130 },
        { field: 'destinationUrn', headerName: 'Destination Urn', width: 150 }
    ];

    const onSubmit = () => {
        if (dbsScheduleList?.length === 0) toast.error("There is no schedules available to create ASN");
        if (vehicleDetails?.length === 0) toast.error("Please add atleast one vehicle");
        else handleLogModalOpen();
    };

    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await createDbsAsn();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogModalOpen(false);
            setIsApiCalled(false);
        }
    };

    const onConfirmSplit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await splitDbsSchedule();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogModalOpen2(false);
            setIsApiCalled(false);
        }
    };

    const handleDateChange = (e, name) => {
        setDetails({ ...details, [name]: e.format(API_DATE_FORMAT) });
    };

    const onUploadCallBack = (docArray) => {
        setDocumentsArray(docArray);
    };

    const vehicleCol = [
        { field: 'vehicleType', headerName: 'Vehicle Type', width: 100 },
        { field: 'vehicleOwnerType', headerName: 'Ownership Type', width: 120 },
        { field: 'vehicleRegistrationNo', headerName: 'Registration No.', width: 130 },
        { field: 'expectedWeight', headerName: 'Expected Weight', width: 130 },
        { field: 'grossVehicleWeight', headerName: 'Gross Vehicle Weight', width: 130 },
        { field: 'unladenWeight', headerName: 'Unladen Weight', width: 100 },
        { field: 'driverName', headerName: 'Driver Name', width: 100 },
        { field: 'licenseNo', headerName: 'License No.', width: 150 },
        { field: 'driverContactNo', headerName: 'Driver Contact No.', width: 130 },
        {
            field: 'view',
            headerName: 'Schedules', width: 100,
            renderCell: (params) => (
                <Tooltip title="View">
                    <IconButton onClick={() => handleClickOpen(params.row)} variant="contained" color="primary">
                        <ViewIcon />
                    </IconButton>
                </Tooltip>
            ),
        },
        {
            field: 'action',
            headerName: 'Action', width: 100,
            renderCell: (params) => (
                <Tooltip title="Remove">
                    <IconButton onClick={() => handleRemoveDetail(params.row)} variant="contained" color="error">
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            ),
        },
    ];

    const handleClickOpen = (row) => {
        const viewData = row?.dbsScheduleList?.map((item) => ({
            "scheduleId": item.scheduleId,
            "weeklyScheduleNumber": item.weeklyScheduleNumber,
            "scheduleLineNumber": item.scheduleLineNumber,
            "scheduleRbCbQuantity": item.scheduleRbCbQuantity,
            "expectedWeight": row.expectedWeight,
            "poNumber": item?.poNumber,
            "destinationType": dbsDetail.destinationStakeholderType,
            "destinationUrn": dbsDetail.destinationStakeholderUrn,
        }));
        setOpenView(true);
        setSelectedRows(viewData);
    };

    const handleClose = () => {
        setOpenView(false);
    };

    const handleScheduleSelection = (ids) => {
        const selected = dbsScheduleList?.filter((schedule) => ids.includes(schedule.id));
        const data = selected.map((item) => ({
            "scheduleId": item.id,
            "weeklyScheduleNumber": item.weeklyScheduleNumber,
            "scheduleLineNumber": item.scheduleLineNumber,
            "schedulePickupDate": item.schedulePickupDate,
            "scheduleRbCbQuantity": item.scheduleRbCbQuantity,
            "poNumber": item.poStpoNumber
        }));
        setSelectedSchedules(data);
        const totalQty = selected.reduce((accumulator, item) => accumulator + item.scheduleRbCbQuantity, 0);
        setTotalScheduleQty(totalQty);
    };

    const toNum = (v) => (v === "" ? NaN : Number(v));

    const recalcExpected = useCallback(() => {
        const g = toNum(details.grossVehicleWeight);
        const u = toNum(details.unladenWeight);
        const t = toNum(totalScheduleQty);

        if (Number.isNaN(g) || Number.isNaN(u) || Number.isNaN(t)) {
            setDetails((d) => ({ ...d, expectedWeight: "" }));
            setErrorMessage((e) => ({ ...e, expectedWeight: "" }));
            return;
        }

        const exp = (g - u) / 1000;

        let msg = "";
        if (g < u) msg = "Gross vehicle weight must be greater than unladen weight.";
        else if (exp < 0) msg = "Expected weight cannot be negative.";
        else if (exp > t) msg = `Expected weight cannot be greater than total weight of selected schedules`;

        setErrorMessage((e) => ({ ...e, expectedWeight: msg }));
        setDetails((d) => ({ ...d, expectedWeight: exp }));
    }, [details.grossVehicleWeight, details.unladenWeight, totalScheduleQty]);

    useEffect(() => {
        recalcExpected();
    }, [recalcExpected]);

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT56</p>}
                <Typography variant="h4" gutterBottom>
                    DBS ASN
                </Typography>
                <Card>
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth required
                                            error={!!errorMessage.urn}
                                            helperText={errorMessage.urn}
                                            label="DBS URN"
                                            value={dbsDetail?.urn}
                                            name="urn"
                                            onChange={(e) => handleInputChange(e)}
                                            inputProps={{ maxLength: 15 }}
                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                                        />
                                        <Button display='flex' alignItems="center" justifyContent="center" style={{ float: "right" }} onClick={() => getDetails()}>Get Details</Button>
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                                            <InputLabel id="selectstakeholder-label">Land Name</InputLabel>
                                            <Select
                                                label="Land Name"
                                                name="landId" value={dbsDetail?.landId || ''} onChange={(e) => handleInputChange(e)}>
                                                <MenuItem><em>Land Name</em></MenuItem>
                                                {growerLandList?.map((item) => (
                                                    <MenuItem key={item.landId} value={item.landId}>{item.landName}</MenuItem>
                                                ))}
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage?.landId}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth disabled label="Name" value={dbsDetail?.name || ''} />
                                        <BadgeComponent currentLength={dbsDetail?.name?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth disabled label="Contact" value={dbsDetail?.mobileNo || ''} />
                                        <BadgeComponent currentLength={dbsDetail?.mobileNo?.length} maxLength={mobileNoMaxLength} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField multiline fullWidth disabled label="Address" value={dbsDetail?.address || ''} />
                                        <BadgeComponent currentLength={dbsDetail?.address?.length} maxLength={addressMaxLength} />
                                    </Grid>
                                    {!decoded.extension_URN && (
                                        <>
                                            <Grid item xs={12} lg={4}>
                                                <FormControl fullWidth sx={{ width: '100%' }}>
                                                    <InputLabel id="selectstakeholder-label">Destination Type</InputLabel>
                                                    <Select
                                                        label="Destination Type"
                                                        name="destinationStakeholderType" value={dbsDetail?.destinationStakeholderType || ''} onChange={(e) => handleInputChange(e)}>
                                                        <MenuItem><em>Destination Type</em></MenuItem>
                                                        <MenuItem hidden={getLocalStorageItem('role') === PIT_ROLES?.PlantSCMOperator} value="LLE">LLE</MenuItem>
                                                        <MenuItem value="Plant">Plant</MenuItem>
                                                        <MenuItem hidden={getLocalStorageItem('role') === PIT_ROLES?.PlantSCMOperator} value="Interim Storage Operator">Interim Storage Operator</MenuItem>
                                                    </Select>
                                                    <FormHelperText sx={{ color: 'red' }}>{errorMessage?.destinationStakeholderType}</FormHelperText>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} lg={4}>
                                                <FormControl sx={{ width: '100%' }}>
                                                    <InputLabel id="selectstakeholder-label">Destination URN</InputLabel>
                                                    <Select
                                                        label="Destination URN"
                                                        name="destinationStakeholderUrn" value={dbsDetail?.destinationStakeholderUrn || ''} onChange={(e) => handleInputChange(e)}>
                                                        <MenuItem><em>Destination URN</em></MenuItem>
                                                        {destinationUrnsList?.map((item) => (
                                                            <MenuItem key={item} value={item}>{item}</MenuItem>
                                                        ))}
                                                    </Select>
                                                    <FormHelperText sx={{ color: 'red' }}>{errorMessage?.destinationStakeholderUrn}</FormHelperText>
                                                </FormControl>
                                            </Grid>
                                        </>
                                    )}
                                    <Grid item xs={12} lg={4}>
                                        <Button endIcon={<ProceedIcon />} sx={{ minWidth: 100, marginTop: "1vh" }} variant="contained" onClick={() => onProceed()}>Proceed</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        {proceed && (
                            <>
                                <Grid item xs={12} mt={1}>
                                    <Typography variant="h5" gutterBottom mt={4} mb={1}>
                                        Vehicle Details
                                    </Typography>

                                    <Grid container spacing={2} mt={1}>
                                        <Grid item xs={12} lg={12} mb={3}>
                                            {selectedSchedules.length > 0 && (
                                                <Paper elevation={0} sx={{ p: 1.5, mb: 2, bgcolor: '#f0f4f8', border: '1px solid #b0bec5', borderRadius: 1 }}>
                                                    <Grid container spacing={2} alignItems="center">
                                                        <Grid item xs={12} sm={6}>
                                                            <Typography variant="body2" color="textSecondary">
                                                                Selected Schedules: <strong>{selectedSchedules.length}</strong>
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <Typography variant="body2" color="primary">
                                                                Total Weight: <strong>{totalScheduleQty ? `${totalScheduleQty} MT` : '0 MT'}</strong>
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Paper>
                                            )}

                                            <Box style={{ height: 450, width: '100%' }}>
                                                <DataGrid
                                                    rows={dbsScheduleList}
                                                    columns={columns}
                                                    pageSize={[5]}
                                                    components={{ Toolbar: QuickSearchToolbar }}
                                                    checkboxSelection
                                                    getRowId={(row) => row.id}
                                                    disableSelectionOnClick
                                                    onSelectionModelChange={(ids) => handleScheduleSelection(ids)}
                                                    isRowSelectable={(params) => !disabledSchedules.includes(params.id)}
                                                />
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                            <FormControl fullWidth required error={!!errorMessage.vehicleType}>
                                                <FormLabel>{t('reg.type')}</FormLabel>
                                                <RadioGroup row>
                                                    <FormControlLabel control={<Radio id="hcv" name="vehicleType" value="HCV" checked={details?.vehicleType === "HCV"} onChange={(e) => handleChange(e)} />} label={t('preReg.hcv')} />
                                                    <FormControlLabel control={<Radio id="mcv" name="vehicleType" value="MCV" checked={details?.vehicleType === "MCV"} onChange={(e) => handleChange(e)} />} label={t('preReg.mcv')} />
                                                    <FormControlLabel control={<Radio id="lcv" name="vehicleType" value="LCV" checked={details?.vehicleType === "LCV"} onChange={(e) => handleChange(e)} />} label={t('preReg.lcv')} />
                                                </RadioGroup>
                                                <FormHelperText>{errorMessage.vehicleType}</FormHelperText>
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                            <FormControl fullWidth required error={!!errorMessage.vehicleOwnerType}>
                                                <FormLabel>{t('preReg.ownnershipType')}</FormLabel>
                                                <RadioGroup row>
                                                    <FormControlLabel control={<Radio id="Owned" name="vehicleOwnerType" value="Owned" checked={details?.vehicleOwnerType === "Owned"} onChange={(e) => handleChange(e)} />} label={t('preReg.owned')} />
                                                    <FormControlLabel control={<Radio id="Rented" name="vehicleOwnerType" value="Rented" checked={details?.vehicleOwnerType === "Rented"} onChange={(e) => handleChange(e)} />} label={t('preReg.rented')} />
                                                </RadioGroup>
                                                <FormHelperText>{errorMessage.vehicleOwnerType}</FormHelperText>
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth
                                                error={!!errorMessage.grossVehicleWeight}
                                                helperText={errorMessage.grossVehicleWeight}
                                                type="number"
                                                onFocus={handleNumberFieldFocus}
                                                label={t('reg.grossVehicleWeight')}
                                                name="grossVehicleWeight"
                                                value={details?.grossVehicleWeight}
                                                onChange={(e) => handleChange(e)}
                                                inputProps={{ maxLength: 10 }}
                                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '+' || evt.key === '-') && evt.preventDefault()}
                                            />
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth
                                                error={!!errorMessage.unladenWeight}
                                                helperText={errorMessage.unladenWeight}
                                                type="number"
                                                onFocus={handleNumberFieldFocus}
                                                label={t('reg.unladenWeight')}
                                                name="unladenWeight"
                                                value={details?.unladenWeight}
                                                onChange={(e) => handleChange(e)}
                                                inputProps={{ maxLength: 10 }}
                                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '+' || evt.key === '-') && evt.preventDefault()}
                                            />
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth
                                                required
                                                error={!!errorMessage.vehicleMake}
                                                helperText={errorMessage.vehicleMake}
                                                type="text"
                                                label={t('reg.vehicleMake')}
                                                name="vehicleMake"
                                                value={details?.vehicleMake}
                                                onChange={(e) => handleChange(e)}
                                                inputProps={{ maxLength: 20 }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth
                                                required
                                                error={!!errorMessage.vehicleModel}
                                                helperText={errorMessage.vehicleModel}
                                                type="text"
                                                label={t('reg.vehicleModel')}
                                                name="vehicleModel"
                                                value={details?.vehicleModel}
                                                onChange={(e) => handleChange(e)}
                                                inputProps={{ maxLength: 20 }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth
                                                required
                                                error={!!errorMessage.vehicleAge}
                                                helperText={errorMessage.vehicleAge}
                                                type="number"
                                                onFocus={handleNumberFieldFocus}
                                                label={t('reg.vehicleAgeInYears')}
                                                name="vehicleAge"
                                                value={details?.vehicleAge}
                                                onChange={(e) => handleChange(e)}
                                                inputProps={{ maxLength: 5 }}
                                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '+' || evt.key === '-') && evt.preventDefault()}
                                            />
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth
                                                error={!!errorMessage.vehicleRegistrationNo}
                                                helperText={errorMessage.vehicleRegistrationNo}
                                                label="Vehicle Registration"
                                                name="vehicleRegistrationNo"
                                                placeholder="Eg: AS01BYXXXX / AS01BXXXX / AS01XXXX"
                                                value={details?.vehicleRegistrationNo}
                                                onChange={(e) => handleChange(e)}
                                                inputProps={{
                                                    maxLength: 20,
                                                    style: { textTransform: "uppercase" }
                                                }}
                                                onKeyDown={(evt) => (evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                                            />
                                            <FileUploadMUI key="VehicleRegistration"
                                                containerName="pit"
                                                documentList={documentsArray}
                                                documentType="VehicleRegistration"
                                                callBackDocumentUpload={onUploadCallBack}
                                                title={t('reg.uploadVehicleRegistrationDoc')}
                                                stakeHolderType="hit"
                                                errorMessage={errorMessage}
                                                setErrorMessage={setErrorMessage}
                                                documentError="registrationDocError"
                                            />
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                            <FormControl fullWidth>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        inputFormat="DD/MM/YYYY"
                                                        renderInput={(params) => <TextField {...params} />}
                                                        sx={{ minWidth: 750 }}
                                                        label={t('reg.endDate')}
                                                        minDate={new Date()}
                                                        name="registrationEndDate"
                                                        value={moment(new Date((details.registrationEndDate))).format(BASIC_DATE_FORMAT)}
                                                        onChange={(e) => handleDateChange(e, "registrationEndDate")}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth
                                                error={!!errorMessage.insuranceNo}
                                                helperText={errorMessage.insuranceNo}
                                                type="text"
                                                label={t('reg.insuranceNo')}
                                                name="insuranceNo"
                                                value={details?.insuranceNo}
                                                onChange={(e) => handleChange(e)}
                                                inputProps={{
                                                    maxLength: 20,
                                                    style: { textTransform: "uppercase" }
                                                }}
                                            />
                                            <FileUploadMUI key="VehicleInsurance"
                                                containerName="pit"
                                                documentList={documentsArray}
                                                documentType="VehicleInsurance"
                                                callBackDocumentUpload={onUploadCallBack}
                                                title={t('reg.uploadInsuranceDoc')}
                                                stakeHolderType="hit"
                                                errorMessage={errorMessage}
                                                setErrorMessage={setErrorMessage}
                                                documentError="insurenaceDocError"
                                            />
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                            <FormControl fullWidth>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        inputFormat="DD/MM/YYYY"
                                                        renderInput={(params) => <TextField {...params} />}
                                                        sx={{ minWidth: 750 }}
                                                        label={t('reg.endDate')}
                                                        minDate={new Date()}
                                                        name="insuranceEnddate"
                                                        value={moment(new Date((details?.insuranceEnddate))).format(BASIC_DATE_FORMAT)}
                                                        onChange={(e) => handleDateChange(e, "insuranceEnddate")}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth
                                                error={!!errorMessage.puccNo}
                                                helperText={errorMessage.puccNo}
                                                type="text"
                                                label={t('reg.puccNo')}
                                                name="puccNo"
                                                value={details?.puccNo}
                                                onChange={(e) => handleChange(e)}
                                                inputProps={{
                                                    maxLength: 20,
                                                    style: { textTransform: "uppercase" }
                                                }}
                                            />
                                            <FileUploadMUI key="VehiclePUCC"
                                                containerName="pit"
                                                documentList={documentsArray}
                                                documentType="VehiclePUCC"
                                                callBackDocumentUpload={onUploadCallBack}
                                                title="Upload PUCC Document"
                                                stakeHolderType="hit"
                                                errorMessage={errorMessage}
                                                setErrorMessage={setErrorMessage}
                                                documentError="puccDocError"
                                            />
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                            <FormControl fullWidth>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        inputFormat="DD/MM/YYYY"
                                                        renderInput={(params) => <TextField {...params} />}
                                                        sx={{ minWidth: 750 }}
                                                        label={t('reg.endDate')}
                                                        minDate={new Date()}
                                                        name="puccEndDate"
                                                        value={moment(new Date((details?.puccEndDate))).format(BASIC_DATE_FORMAT)}
                                                        onChange={(e) => handleDateChange(e, "puccEndDate")}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth
                                                error={!!errorMessage.fitnessNo}
                                                helperText={errorMessage.fitnessNo}
                                                type="text"
                                                label="Fitness No."
                                                name="fitnessNo"
                                                value={details?.fitnessNo}
                                                onChange={(e) => handleChange(e)}
                                                inputProps={{
                                                    maxLength: 20,
                                                    style: { textTransform: "uppercase" }
                                                }}
                                            />
                                            <FileUploadMUI key="FitnessNo"
                                                containerName="pit"
                                                documentList={documentsArray}
                                                documentType="FitnessNo"
                                                callBackDocumentUpload={onUploadCallBack}
                                                title="Upload Fitness Document"
                                                stakeHolderType="hit"
                                                errorMessage={errorMessage}
                                                setErrorMessage={setErrorMessage}
                                                documentError="fitnessDocError"
                                            />
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                            <FormControl fullWidth>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        inputFormat="DD/MM/YYYY"
                                                        renderInput={(params) => <TextField {...params} />}
                                                        sx={{ minWidth: 750 }}
                                                        label={t('reg.endDate')}
                                                        minDate={new Date()}
                                                        name="fitnessEndDate"
                                                        value={moment(new Date((details?.fitnessEndDate))).format(BASIC_DATE_FORMAT)}
                                                        onChange={(e) => handleDateChange(e, "fitnessEndDate")}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth
                                                error={!!errorMessage.expectedWeight}
                                                helperText={errorMessage.expectedWeight}
                                                type="number"
                                                label="Expected Weight (MT)"
                                                name="expectedWeight"
                                                value={details?.expectedWeight}
                                                onChange={(e) => handleChange(e)}
                                            />
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth
                                                error={!!errorMessage.driverName}
                                                helperText={errorMessage.driverName}
                                                type="text"
                                                label="Driver Name"
                                                name="driverName"
                                                value={details?.driverName}
                                                onChange={(e) => handleChange(e)}
                                                inputProps={{ maxLength: 60 }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth
                                                error={!!errorMessage.licenseNo}
                                                helperText={errorMessage.licenseNo}
                                                type="text"
                                                label="License No."
                                                name="licenseNo"
                                                value={details?.licenseNo}
                                                onChange={(e) => handleChange(e)}
                                                inputProps={{
                                                    maxLength: 20,
                                                    style: { textTransform: "uppercase" }
                                                }}
                                            />
                                            <FileUploadMUI key={DRIVING_LICENSE}
                                                containerName="pit"
                                                documentList={documentsArray}
                                                documentType={DRIVING_LICENSE}
                                                callBackDocumentUpload={onUploadCallBack}
                                                title="Upload Driving License Document"
                                                stakeHolderType="hit"
                                                errorMessage={errorMessage}
                                                setErrorMessage={setErrorMessage}
                                                documentError="drivingLicenseDocError"
                                            />
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth
                                                error={!!errorMessage.driverContactNo}
                                                helperText={errorMessage.driverContactNo}
                                                type="text"
                                                label="Driver Contact No."
                                                name="driverContactNo"
                                                value={details?.driverContactNo}
                                                onChange={(e) => handleChange(e)}
                                                inputProps={{ maxLength: 10 }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} lg={12} display="flex" justifyContent="flex-end" mt={2}>
                                            <Button variant="contained" color="primary" onClick={handleAddDetail} startIcon={<AddIcon />}>
                                                Add Vehicle
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {vehicleDetails.length > 0 && (
                                    <Grid item xs={12} mt={4}>
                                        <Typography variant="h6" gutterBottom>
                                            Added Vehicles
                                        </Typography>
                                        <Box style={{ height: 300, width: '100%' }}>
                                            <DataGrid
                                                rows={vehicleDetails}
                                                columns={vehicleCol}
                                                pageSize={[5]}
                                                getRowId={(row) => row.vehicleRegistrationNo}
                                                disableSelectionOnClick
                                            />
                                        </Box>
                                        <Box display="flex" justifyContent="center" mt={3}>
                                            <Button variant="contained" color="success" onClick={onSubmit} startIcon={<SubmitIcon />}>
                                                Submit ASN
                                            </Button>
                                        </Box>
                                    </Grid>
                                )}
                            </>
                        )}
                    </CardContent>
                </Card>
            </Container>

            <Dialog open={openView} onClose={handleClose} maxWidth="lg" fullWidth>
                <DialogTitle>Schedule Details</DialogTitle>
                <DialogContent>
                    <Box style={{ height: 350, width: '100%' }}>
                        <DataGrid
                            rows={selectedRows}
                            columns={viewScheduleCol}
                            pageSize={[5]}
                            getRowId={(row) => row.scheduleId}
                            disableSelectionOnClick
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={logModalOpen} onClose={handleLogModalClose}>
                <DialogTitle>Confirm Submission</DialogTitle>
                <DialogContent>
                    <Typography>Are you sure you want to create the DBS ASN with the selected vehicles?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleLogModalClose}>Cancel</Button>
                    <Button onClick={onConfirmSubmit} color="primary" variant="contained" disabled={isApiCalled}>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={logModalOpen2} onClose={handleLogModalClose2}>
                <DialogTitle>Split Schedule Confirmation</DialogTitle>
                <DialogContent>
                    <Typography>Expected weight differs from schedule total weight. Do you want to split the DBS schedule?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleLogModalClose2}>Cancel</Button>
                    <Button onClick={onConfirmSplit} color="primary" variant="contained" disabled={isApiCalled}>
                        Split & Proceed
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default AsnGrnViewDetails;
